import { api } from '../api';

export const parserApi = api.injectEndpoints({
  endpoints: build => ({
    getParserData: build.query({
      query: ({ token, source, id, url, per_page, sort_order, sort_by = 'id', page }) => {
        // Build query string from non-empty params only
        const params = new URLSearchParams();

        if (source !== undefined && source !== '') {
          params.append('source', source);
        }
        if (id !== undefined && id !== '') {
          params.append('id', id);
        }
        if (url !== undefined && url !== '') {
          params.append('url', url);
        }
        if (per_page !== undefined && per_page !== '') {
          params.append('per_page', per_page);
        }
        if (sort_order !== undefined && sort_order !== '') {
          params.append('sort_order', sort_order);
        }
        if (page !== undefined && page !== '') {
          params.append('page', page);
        }
        if (sort_by !== undefined && sort_by !== '') {
          params.append('sort_by', sort_by);
        }

        const queryString = params.toString();
        const url_path = queryString ? `api/parser-data?${queryString}` : 'api/parser-data';

        return {
          url: url_path,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      providesTags: ['ParserData'],
    }),
    getSpiders: build.query({
      query: ({ token }) => ({
        url: 'api/parser-data/spiders',
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      }),
      providesTags: ['SpiderList'],
    }),
    getParserStats: build.query({
      query: ({ token, source }) => {
        const params = new URLSearchParams();
        if (source !== undefined && source !== '') {
          params.append('source', source);
        }
        const qs = params.toString();
        return {
          url: qs ? `api/parser-data/stats?${qs}` : 'api/parser-data/stats',
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      providesTags: ['ParserStats'],
    }),
    getParserSessionsHistory: build.query({
      query: ({ token, limit = 20 }) => ({
        url: `api/parser-data/sessions-history?limit=${limit}`,
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      }),
      providesTags: ['ParserSessionsHistory'],
    }),
    getTaskAdverts: build.query({
      query: ({ token, taskId, perPage = 50, page = 1, eventType = 'Added' }) => {
        const params = new URLSearchParams();
        params.append('per_page', perPage);
        params.append('page', page);
        params.append('event', eventType);
        return {
          url: `api/parser-data/tasks/${taskId}/adverts?${params.toString()}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      providesTags: (result, error, { taskId, eventType = 'Added' }) => [
        { type: 'TaskAdverts', id: `${taskId}-${eventType}` },
      ],
    }),
    getAdvertChangeDiff: build.query({
      query: ({ token, eventId }) => ({
        url: `api/parser-data/events/${eventId}/diff`,
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      }),
      providesTags: (result, error, { eventId }) => [
        { type: 'AdvertChangeDiff', id: eventId },
      ],
    }),
  }),
});

export const {
  useGetParserDataQuery,
  useGetSpidersQuery,
  useGetParserStatsQuery,
  useGetParserSessionsHistoryQuery,
  useGetTaskAdvertsQuery,
  useGetAdvertChangeDiffQuery,
} = parserApi;
